import { render, staticRenderFns } from "./EditRetention.vue?vue&type=template&id=78206323&scoped=true&"
import script from "./EditRetention.vue?vue&type=script&lang=js&"
export * from "./EditRetention.vue?vue&type=script&lang=js&"
import style0 from "./EditRetention.vue?vue&type=style&index=0&id=78206323&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78206323",
  null
  
)

export default component.exports